// Logi diagnostyczne sa domyslnie wylaczone (zasmiecaja konsole i wypisywaly dane uzytkownika).
// Wlaczenie bez przebudowy: w konsoli `localStorage.setItem('pso_debug', '1')` i odswiezenie strony.
export const DEBUG = (() => {
    try {
        return window.localStorage.getItem('pso_debug') === '1';
    } catch (e) {
        return false;
    }
})();
